import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBatchOrderRouting extends Layout {
    sourceEquipmentGroup: DataSource;
    tableBatchOrderRouting: Table;
}
